var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"0 auto","padding":"12px","width":"fit-content"}},[_c('span',{staticStyle:{"color":"#A1A1A1","font-size":"12px","font-weight":"600"}},[_vm._v("by VC360")])])
}]

export { render, staticRenderFns }